import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/src/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/src/layouts/auth.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/src/layouts/blank.vue").then(m => m.default || m)),
  chat: defineAsyncComponent(() => import("/src/layouts/chat.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m)),
  header: defineAsyncComponent(() => import("/src/layouts/header.vue").then(m => m.default || m))
}